import { render, staticRenderFns } from "./IpTrafficPointDetails.vue?vue&type=template&id=8695235a&"
import script from "./IpTrafficPointDetails.vue?vue&type=script&lang=js&"
export * from "./IpTrafficPointDetails.vue?vue&type=script&lang=js&"
import style0 from "./IpTrafficPointDetails.vue?vue&type=style&index=0&id=8695235a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports